<template>
  <div
    :class="
      $cn(
        {
          'mx-auto': !noCenter,
          'max-w-3xl': size === 'xs',
          'max-w-4xl': size === 'sm',
          'max-w-5xl': size === 'md',
          'max-w-6xl': size === 'lg',
          'max-w-7xl': size === 'xl',
          'container': size === 'container'
        },
        ui?.base
      )
    "
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
import type { ClassValue } from 'clsx'

export type ContainerSize = 'container' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'full'

withDefaults(
  defineProps<{
    noCenter?: true
    size?: ContainerSize
    ui?: Partial<{
      base: ClassValue
    }>
  }>(),
  {
    size: 'container'
  }
)
</script>
